var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWomanbasıctrıangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "katman 2",
    viewBox: "0 0 12.01 10.01",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "katman 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0 0 12.01 0 6 10.01",
    strokeWidth: "0px"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWomanbasıctrıangle);
export default __webpack_public_path__ + "static/media/WOMANBASICTRIANGLE.cc883f7409512ebb1e07dcacd251b295.svg";
export { ForwardRef as ReactComponent };